<template>
  <svg class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 10.5H3.5" stroke-width="2" stroke-linecap="round"/>
    <path d="M14 10.5H16.5" stroke-width="2" stroke-linecap="round"/>
    <path d="M13.5 7L15 5.5" stroke-width="2" stroke-linecap="round"/>
    <path d="M10 5.5L10 3" stroke-width="2" stroke-linecap="round"/>
    <path d="M5 5.5L6.5 7" stroke-width="2" stroke-linecap="round"/>
    <path d="M10 17L10 9.5" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>